import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { Store } from '@ngrx/store';
import { Observable, filter, debounceTime, distinctUntilChanged, map } from 'rxjs';
import { AppState } from 'src/app/reducers';
import { User, UserToken } from '../../auth/model/user.model';
import { MsgModel } from '../../common-components/msg/model/msg.model';
import { UserProfileService } from '../service/user-profile.service';

@Component({
    selector: 'input-username',
    templateUrl: './input-username.component.html',
    styleUrls: ['./input-username.component.scss']
})
export class InputUsernameComponent implements OnInit {
    @Input() matLabel: string = 'Username';
    @Input() placeholder: string = 'Username';
    @Input() form!: UntypedFormGroup;
    @Input() controlName!: string;
    @Input() givenUser: User = new User();

    userToken: UserToken = {};
    currentUser: User = new User();
    isLoading: boolean = false;
    msg!: MsgModel;

    myControl: any;
    filteredOptions!: Observable<any>;

    minCharacters: number = 1;

    constructor(private userProfileService: UserProfileService, private store: Store<AppState>) {}

    ngOnInit(): void {
        this.myControl = <UntypedFormControl>this.form.get(this.controlName);
        const userToken = localStorage.getItem('userToken') || '';
        this.userToken = userToken ? JSON.parse(userToken.toString()) : undefined;
        this.currentUser = this.userToken ? this.userToken.user! : this.givenUser;

        this.filteredOptions = this.myControl.valueChanges.pipe(
            // only search if search string is >= 3 characters
            filter((text: string) => text !== null && text.length >= this.minCharacters && this.validateUsername(text)),
            debounceTime(1000),
            //distinctUntilChanged(),
            map((value) => this.checkUsername(value))
        );
    }

    checkUsername(userId: any) {
        this.isLoading = true;

        this.userProfileService
            .checkUserId(userId, this.currentUser.ID!)
            .pipe()
            .subscribe((res) => {
                if (res) {
                    if (res.msg ? res.msg.SUCCESS : false) {
                        this.msg = res.msg;
                        this.isLoading = false;
                    } else {
                        this.myControl.setErrors({ username: true });
                        this.msg = res.msg;
                        this.isLoading = false;
                    }
                } else {
                    this.myControl.setErrors({ username: true });
                    this.msg = { MSG: 'This username is not valid.', SUCCESS: false };
                    this.isLoading = false;
                }
            });
    }

    validateUsername(username: string) {
        let userIdRegex = new RegExp('^(?!.*[._]{2})[A-Za-z]{1,}[A-Za-z0-9-_:.]{2,}$');

        const isUsername = userIdRegex.test(username);

        this.myControl.setErrors(isUsername ? null : { username: true });
        this.msg = isUsername ? {} : { MSG: 'This username is not valid.', SUCCESS: false };

        return isUsername;
    }
}
